module.exports = __webpack_public_path__ + "static/media/500SunsetAveNW_2018-06-06_55.8e7df90e.jpg";